import { render, staticRenderFns } from "./BaseInputField.vue?vue&type=template&id=2c07ce29&scoped=true"
import script from "./BaseInputField.vue?vue&type=script&lang=js"
export * from "./BaseInputField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c07ce29",
  null
  
)

export default component.exports